enum InterviewType {
    Presentation = 'presentation',
    JobInvestigation = 'job-investigation',
    MarketAppropriateness = 'market-appropriateness',
    Targeting = 'targeting',
    JobInterviewPreparation = 'job-interview-preparation',
    JobInterviewPreparationOther = 'job-interview-preparation-other',
    PreSelection = 'pre-selection',
    Recruitment = 'recruitment',
    Discovery = 'discovery',
    ProductPresentation = 'product-presentation',
    CommercialProposition = 'commercial-proposition',
    Negotiation = 'negotiation',
    Coffee = 'coffee',
    Meal = 'meal',
    Dinner = 'dinner',
    BilanInterview = 'bilan-interview',
    FollowUpInterview = 'follow-up-interview',
    Other = 'other',
}

export default InterviewType;
